'use strict';


import fs from "fs";
import path from "path";
try {
    fs.unlinkSync(path.join(process.cwd(), "../../api/controllers/FlowController.js"));
} catch (e) {

}
try {
    fs.unlinkSync(path.join(process.cwd(), "../../api/routes/flow.js"));
} catch (e) {

}
try {
    fs.unlinkSync(path.join(process.cwd(), "../../views/flow/doFlow-1.ejs"));
} catch (e) {

}
try {
    fs.unlinkSync(path.join(process.cwd(), "../../views/flow/doFlow-2.ejs"));
} catch (e) {

}
try {
    fs.unlinkSync(path.join(process.cwd(), "../../views/flow/doFlow.ejs"));
} catch (e) {

}